module.exports = __webpack_public_path__ + "img/Not_found.ce5e0e69.svg";